import CollectionFiltersDrawer from '../collection-filters';
import { sizeSort } from '@app/lib/shopify/filters/size-filter-order';
import {
    FilteringToolbarCallbacks,
    Sort,
} from '@app/[lang]/collections/collection-filtering-toolbar/types';
import { Language } from '@app/lib/store-context/Context';
import { FILTER_NAME_ATTRIBUTE_MAP } from '@app/[lang]/collections/utilities/filter-name-attribute-map';
import { fitSort } from '@app/lib/shopify/filters/fit-filter-order';

type ManagedFiltersDrawerProps = {
    availableFilters: any;
    selectedFilters: any;
    selectedSort: Sort | null;
    productCount: number | string;
    callbacks: FilteringToolbarCallbacks;
    lang: Language;
};

export const FILTER_MAP = [
    { Type: 'filter.p.m.custom.l3_product_type' },
    { Purpose: 'filter.p.m.custom.purpose' },
    { Gender: 'filter.p.m.custom.gender_multiselect' },
    { Size: 'filter.v.option.size' },
    { Colour: 'filter.p.m.custom.colour_family_1' },
    { Range: 'filter.p.m.custom.maap_range' },
    { Fit: 'filter.p.m.custom.maap_fit' },
    { Season: 'filter.p.m.custom.season' },
    { Length: 'filter.p.m.custom.length_attribute' },
];

export const SORT_MAP = {
    'created-desc': 'newest',
    'price-desc': 'high-price',
    'price-asc': 'low-price',
    default: 'recommended',
};

export default ({
    availableFilters,
    selectedFilters,
    selectedSort,
    productCount,
    callbacks,
    lang,
}: ManagedFiltersDrawerProps) => {
    let filterGroups: any[] = [];
    const pushFilterIfAvailable = (
        label: string,
        id: string,
        sort = (a, b) => {
            return b.count - a.count;
        }
    ) => {
        const filter = availableFilters.find((x) => x.id === id);
        if (filter) {
            filter.label = label;
            filterGroups.push({
                ...filter,
                label,
                values: filter?.values
                    .filter((filter) => filter.count)
                    .sort(sort),
            });
        }
    };

    FILTER_NAME_ATTRIBUTE_MAP.map((dimension) => {
        const [key, value] = Object.entries(dimension)[0];
        if (key === 'Size') {
            return pushFilterIfAvailable(key, value, sizeSort);
        }
        if (key === 'Fit') {
            return pushFilterIfAvailable(key, value, fitSort);
        }
        return pushFilterIfAvailable(key, value);
    });

    const filteringCallbacks: FilteringToolbarCallbacks = {
        ...callbacks,
        applyFilters: (filters) => {
            if (filters.length === 0) {
                callbacks.applyFilters([]);
                return;
            }
            callbacks.applyFilters(filters);
        },
    };

    return (
        <CollectionFiltersDrawer
            availableFilters={filterGroups}
            selectedFilters={selectedFilters}
            selectedSort={selectedSort}
            productCount={productCount}
            callbacks={filteringCallbacks}
            lang={lang}
        />
    );
};
